import { Html, html, rune, View } from 'rune-ts';
import { CreatorTypeS } from '@services/MarppleShop/features/Creator/outbound/share.ts';
import { makeDefaultProfileImg } from '@services/MarppleShop/shared/util/helper.ts';
import { map, pipe, take, toArray } from '@fxts/core';
import { ProductThumbnailOption } from '@services/MarppleShop/features/ProductList/type';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr.ts';
import { makeSubScreenNavigate } from '@services/MarppleShop/shared/app/navigate.ts';
import { ProductThumbnail } from '@services/MarppleShop/renderApp/components/cells/ProductThumbnail/ProductThumbnail.ts';
import { getResizedImage70WebpUrl } from '@services/MarppleShop/shared/util/getResizedImageUrl.ts';
import { MShopDefaultIcon } from '@services/MarppleShop/renderApp/components/atoms/Icon';
import baseKlass from './BaseCreatorRankerCard.module.scss';
import { MShopUtilF } from '@modules/MShop/Util/F/Function/module/MShopUtilF';
import { navigateTo } from '@services/MarppleShop/shared/app/util.ts';

interface BaseCreatorRankerProps {
  creator_ranking: CreatorTypeS.ICreatorRanking;
}

export class BaseCreatorRankerCard<
  Props extends BaseCreatorRankerProps = BaseCreatorRankerProps,
> extends View<Props> {
  static BACKGROUND_IMG_WIDTH = 400;
  static PRODUCT_COUNT_PC = 3;
  static PRODUCT_COUNT_MO = 4;

  protected override onRender() {
    this.delegate('click', `.${baseKlass.base_creator_ranker_card_best_product}`, (event) => {
      event?.originalEvent.preventDefault();
      const div = event.currentTarget as HTMLDivElement;
      navigateTo(div.dataset.href || '', makeSubScreenNavigate);
    });
  }

  get defaultImage() {
    return makeDefaultProfileImg(300);
  }

  get mShopDefaultIcon() {
    return MShopDefaultIcon();
  }

  get isApp(): boolean {
    return MShopUtilF.isApp();
  }

  get isMobile(): boolean {
    return !!rune.getSharedData(this)?.is_mobile;
  }

  public createContainerWithBackdrop(view: string | Html | View, klass?: string) {
    return html`
      <div class="${baseKlass.base_creator_ranker_card} ${klass}">${this._makeBackgroundHtml()}${view}</div>
    `;
  }

  public makeProductImages(klass?: string) {
    return pipe(
      this.data.creator_ranking.products,
      map((product) => {
        const option: ProductThumbnailOption = {
          resize_width: 600,
          img_alt: product.name || '',
        };
        const uri = `/${ET.lang}/${this.data.creator_ranking.domain_name}/products/${product.id}`;

        return html`<div
          data-href="${uri}"
          data-product-post-message="${dataStr(makeSubScreenNavigate(uri))}"
          class="${baseKlass.base_creator_ranker_card_best_product} ${klass}"
        >
          ${new ProductThumbnail(product, option)}
        </div>`;
      }),
      take(this.isMobile ? BaseCreatorRankerCard.PRODUCT_COUNT_MO : BaseCreatorRankerCard.PRODUCT_COUNT_PC),
      toArray,
    );
  }

  private _makeBackgroundHtml() {
    const { thumbnail_img } = this.data.creator_ranking;

    return html`<img
      class="${baseKlass.base_creator_ranker_card_backdrop}"
      src="${getResizedImage70WebpUrl(
        thumbnail_img || this.defaultImage,
        BaseCreatorRankerCard.BACKGROUND_IMG_WIDTH,
      )}"
      alt="backdrop"
    />`;
  }
}
